
<div class="wp-card" [style.background-color]="isSeqNoEven ? '#daf4f5' : '#c2cfd8'">

    <div class="form-group row mt-0 mb-0">
        <label for="variableName" class="col-sm-5 col-form-label col-form-label-sm align-self-center">
            {{variableName}} {{dataType}} {{vpivId}}
        </label>
        <div class="col-sm-7">
            <input type="text" class="form-control form-control-sm input-sm" id="variableName"
                 [(ngModel)]="variableValue" (change)="onChangeVariableValue($event, vpivId)">
        </div>
    </div>

</div>

